import tamogatasKalkulatorServiceModule from './tamogataskalkulator-service';
import hektarValidator from './validators/hektarvalidator';
import okohektarValidator from './validators/okohektarvalidator';
const MODULE_NAME = 'tamogatasKalkulator';
class TamogatasKalkulatorController {
	constructor(tamogatasKalkulatorService, $scope) {
		'ngInject';
		this._tamogatasKalkulatorService = tamogatasKalkulatorService;
		this.formData = {
			hektar: '0',
			fiatal: 'false',
			okohektar: '0',
			euro: ''
		};
		this.fiatalok = [{
			name: 'true',
			value: 'Igen'
		},
		{
			name: 'false',
			value: 'Nem'
		}];
		this.currentYear = new Date().getFullYear();
		this.nextYear = this.currentYear + 1;
		this.nextYearPlusOne = this.currentYear + 2;
		this._$scope = $scope;
	}
	$onInit() {
		this._$scope.$watch('$ctrl.formData.hektar', () => {
			this._$scope.$ctrl.hitelForm.okohektar.$validate();
		});
	}
	calculateSubmit(event) {
		event.preventDefault();
		this.calculateSubmitted = true;
		this.calculatedData = false;
		if (this.hitelForm.$valid) {
			this._tamogatasKalkulatorService.calculate(this.formData).then((response) => {
				this.calculatedData = response;
			}, () => {
				this.technikaiHiba = true;
			});
		}
	}
}
export default angular.module(MODULE_NAME, [tamogatasKalkulatorServiceModule, 'ngMessages', hektarValidator, okohektarValidator])
	.controller('tamogatasKalkulator', TamogatasKalkulatorController).name;



// WEBPACK FOOTER //
// ./source/applications/kalkulator/tamogataskalkulator/tamogataskalkulator.js